import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AudienceModule } from './live-mode/audience/audience.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { LiveModeComponent } from './live-mode/live-mode.component';
import { CreditsDisplayComponent } from './credits-display.component';
import { CartDisplayComponent } from './cart-display.component';
import { FormErrorsComponent } from '../form_errors/form_errors.component';

const components = [LiveModeComponent, CreditsDisplayComponent, CartDisplayComponent, FormErrorsComponent];

@NgModule({
  imports: [CommonModule, TranslateModule, AudienceModule, TooltipModule],
  declarations: [...components],
  exports: components
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/modules/shared/shared.module.ts